<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" />
<div class="d-flex text-center flex-column flex-column-fluid background-cd background">
  <div class="container-fluid p-5 sign-in-container rounded">
    <!-- Logo -->
    <h2 class="d-flex justify-content-center logo" routerLink="">
      <img src="../../../assets/img/logo.svg" alt="sameta-logo" class="mb-3 mt-3 w-75" />
    </h2>
    @if (registerForm){
    <form [formGroup]="registerForm" data-testid="register-form">
      <h2 data-testid="register-title">{{ 'register.title' | translate }}</h2>
      @if(!isGoogle){
      <h3 class="d-flex justify-content-center align-items-center">
        <p class="opacity_text mb-0 me-2">{{ 'login.alreadyHaveAccount' | translate }}</p>
        <a routerLink="/login" data-testid="register-login-link">{{ 'login.logIn' | translate }}</a>
      </h3>
      <div
        class="col-sm btn btn-sm border d-flex align-items-start justify-content-center custom-btn"
        (click)="googleAuth()"
        data-testid="register-google-auth-button">
        <img class="me-2" alt="" src="../../../assets/img/google.svg" />
        <p class="mb-0">Use Google</p>
      </div>
      <div class="row mt-3 mb-3 align-items-center">
        <div class="col-5 d-flex"><hr class="w-100" /></div>
        <div class="col-2 text-center middle-text opacity_text"><h3>OR</h3></div>
        <div class="col-5"><hr class="w-100" /></div>
      </div>
      }
      <div class="d-flex flex-column">
        <div class="mb-3 d-flex flex-column align-items-start">
          <label class="form-label w-100 text-start" data-testid="register-company-label">
            {{ 'firmRegistration.firmL' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="company"
            autocomplete="organization"
            placeholder="{{ 'firmRegistration.firmL' | translate }}"
            data-testid="register-company-input"
            [ngClass]="{ 'border border-danger': registerForm.get('company')?.dirty && registerForm.get('company')?.invalid }" />
          <div *ngIf="registerForm.get('company')?.dirty && registerForm.get('company')?.invalid" class="text-danger mt-1 text-start d-flex align-items-center">
            <i class="bi bi-exclamation-circle-fill me-2"></i>
            {{ 'shared.fieldError' | translate }}
          </div>
        </div>
        <div class="mb-3 d-flex flex-column align-items-start">
          <label class="form-label w-100 text-start" data-testid="register-firstname-label">
            {{ 'questions.finalStepName' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="firstName"
            autocomplete="given-name"
            placeholder="{{ 'questions.finalStepName' | translate }}"
            data-testid="register-firstname-input"
            [ngClass]="{ 'border border-danger': registerForm.get('firstName')?.dirty && registerForm.get('firstName')?.invalid }" />
          <div
            *ngIf="registerForm.get('firstName')?.dirty && registerForm.get('firstName')?.invalid"
            class="text-danger mt-1 text-start d-flex align-items-center">
            <i class="bi bi-exclamation-circle-fill me-2"></i>
            {{ 'shared.fieldError' | translate }}
          </div>
        </div>
        <div class="mb-3 d-flex flex-column align-items-start">
          <label class="form-label w-100 text-start" data-testid="register-lastname-label">
            {{ 'questions.finalStepSurname' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="lastName"
            autocomplete="family-name"
            placeholder="{{ 'questions.finalStepSurname' | translate }}"
            data-testid="register-lastname-input"
            [ngClass]="{ 'border border-danger': registerForm.get('lastName')?.dirty && registerForm.get('lastName')?.invalid }" />
          <div
            *ngIf="registerForm.get('lastName')?.dirty && registerForm.get('lastName')?.invalid"
            class="text-danger mt-1 text-start d-flex align-items-center">
            <i class="bi bi-exclamation-circle-fill me-2"></i>
            {{ 'shared.fieldError' | translate }}
          </div>
        </div>
        <div class="mb-3 d-flex flex-column align-items-start">
          <label class="form-label w-100 text-start" data-testid="register-email-label">
            {{ 'stepperForm.personalInfo.email' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            id="email"
            type="email"
            class="form-control"
            formControlName="email"
            autocomplete="email"
            placeholder="{{ 'stepperForm.personalInfo.email' | translate }}"
            data-testid="register-email-input"
            [ngClass]="{ 'border border-danger': registerForm.get('email')?.dirty && registerForm.get('email')?.invalid }" />
          <div *ngIf="registerForm.get('email')?.dirty && registerForm.get('email')?.invalid" class="text-danger mt-1 text-start d-flex align-items-center">
            <i class="bi bi-exclamation-circle-fill me-2"></i>
            {{ 'shared.emailErroInvalid' | translate }}
          </div>
        </div>
      </div>
      @if(!isGoogle){
      <div class="mb-4">
        <div class="input-group">
          <label class="form-label w-100 text-start" data-testid="register-password-label">
            {{ 'shared.password' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="{{ hidePS1 ? 'password' : 'text' }}"
            class="form-control"
            id="password"
            formControlName="password"
            placeholder="{{ 'shared.password' | translate }}"
            data-testid="register-password-input"
            autocomplete="new-password"
            [ngClass]="{ 'border border-danger': registerForm.get('password')?.dirty && registerForm.get('password')?.invalid }" />
          <button
            class="btn btn-outline-secondary opacity_text"
            type="button"
            (click)="toggleHidePassword('PS1')"
            data-testid="register-toggle-password-button">
            <i class="bi" [ngClass]="hidePS1 ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div *ngIf="registerForm.get('password')?.dirty && registerForm.get('password')?.invalid" class="text-danger mt-1 text-start d-flex align-items-center">
          <i class="bi bi-exclamation-circle-fill me-2"></i>
          {{ 'shared.passwordErrorForm' | translate }}
        </div>
      </div>
      <div class="mb-4">
        <div class="input-group">
          <label class="form-label w-100 text-start" data-testid="register-verify-password-label">
            {{ 'shared.verifyPassword' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="{{ hidePS2 ? 'password' : 'text' }}"
            class="form-control"
            id="verifyPassword"
            formControlName="verifyPassword"
            placeholder="{{ 'shared.verifyPassword' | translate }}"
            autocomplete="new-password"
            data-testid="register-verify-password-input"
            [ngClass]="{ 'border border-danger': registerForm.get('verifyPassword')?.dirty && registerForm.get('verifyPassword')?.invalid }" />
          <button
            class="btn btn-outline-secondary opacity_text"
            type="button"
            (click)="toggleHidePassword('PS2')"
            data-testid="register-toggle-verify-password-button">
            <i class="bi" [ngClass]="hidePS2 ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div
          *ngIf="
            registerForm.get('verifyPassword')?.dirty && registerForm.get('verifyPassword')?.invalid && registerForm.get('verifyPassword').value.length > 0
          "
          class="text-danger mt-1 text-start d-flex align-items-center">
          <i class="bi bi-exclamation-circle-fill me-2"></i>
          {{ 'shared.verifyPasswordErrorMatch' | translate }}
        </div>
      </div>
      }
      <div class="form-check">
        <mat-checkbox class="button-like" formControlName="marketing" data-testid="register-marketing-checkbox"></mat-checkbox>
        <div class="d-flex gap-1">
          <p class="finalCheckbox">
            {{ 'questions.finalStepMarketingPart1' | translate }}
            <a routerLink="/privacy-policy" target="_blank" data-testid="register-privacy-policy-link">
              {{ 'questions.finalStepPrivacyPolicyLink' | translate }}
            </a>
          </p>
        </div>
      </div>
      <div class="form-check">
        <mat-checkbox class="button-like" formControlName="privacyPolicy" required data-testid="register-privacy-policy-checkbox"></mat-checkbox>
        <div class="d-flex gap-1">
          <span class="text-danger">*</span>
          <p class="finalCheckbox">
            {{ 'questions.finalStepPrivacyPolicyPart1' | translate }}
            <a routerLink="/terms-of-use" target="_blank" data-testid="register-terms-of-use-link">
              {{ 'questions.finalStepPrivacyPolicyTermsOfUse' | translate }}
            </a>
            {{ 'questions.finalStepPrivacyPolicyPart2' | translate }}
            <a routerLink="/privacy-policy" target="_blank" data-testid="register-privacy-policy-link-2">
              {{ 'questions.finalStepPrivacyPolicyLink' | translate }}
            </a>
          </p>
        </div>
      </div>
      <div
        *ngIf="registerForm.get('privacyPolicy')?.touched && registerForm.get('privacyPolicy')?.invalid"
        class="text-danger mt-1 mb-2 text-start d-flex align-items-center">
        <i class="bi bi-exclamation-circle-fill me-2"></i>
        {{ 'register.privacyPolicyRequired' | translate }}
      </div>
      <button
        class="btn btn-secondary button-color flex-column center-class"
        [ngClass]="{ 'disabled-look': !registerForm.valid }"
        (click)="register()"
        data-testid="register-submit-button">
        {{ 'register.register' | translate }}
      </button>
    </form>
    }
  </div>
</div>
